<template>
  <div class="detection-control-wrap">
    <start-button @switch="emitStart" :loading="loading" :status="status" />
    <mode-button
      v-for="item in btns"
      :key="item.mode"
      :enabled="status === 'stop'"
      v-bind="item"
      :active="mode"
      @switch="$emit('update:mode', $event)"
    />
  </div>
</template>

<script>
import StartButton from './start-btn.vue';
import ModeButton from './mode-btn.vue';

export default {
  name: 'VPDetectionControl',
  components: {
    StartButton,
    ModeButton
  },
  inject: ['calc'],
  props: {
    mode: {
      type: String,
      default: 'quick'
    },
    status: {
      type: String,
      default: 'stop'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      btns: [{ mode: 'quick' }, { mode: 'deep' }, { mode: 'simple' }, { mode: 'plus' }]
    };
  },
  methods: {
    emitStart(status) {
      this.$emit('update:status', status);
      this.$emit('click', this.mode, status);
    }
  }
};
</script>

<style lang="scss" scoped>
.detection-control-wrap {
  position: relative;
  width: 100%;
  padding-bottom: 51%;
}
</style>
